// Routes this page does NOT serve → the page that does (DR-0045 D3/D4). On an
// ACT site that is Firestrike's own subdomain (ACT HQ DR-0017), in dev the
// proxied /firestrike/ path. Import-light on purpose: main.ts uses it on the
// pre-boot redirect path, which must stay feather-light (no engine, no core
// graph; the pages module is a few constants).
import { FIRESTRIKE_PAGE_BASE } from "@act/client-core/pages";

export const FOREIGN_ROUTES: Readonly<Record<string, string>> = Object.fromEntries(
  ["wave-lobby", "wave-game", "wave-solo", "local-combat-benchmark", "mobile-foundation-benchmark"].map(
    (route) => [route, FIRESTRIKE_PAGE_BASE],
  ),
);
